import { useQuery } from '@tanstack/react-query';
import { useAppContext } from 'src/contexts/AppContext';
import { ErrorTypes, useClientLogContext } from 'src/contexts/ClientLogContext';
import { RetailClient } from 'src/WebApiController';

export function useGetBuyerDetail(buyerEmail: string | null) {
  const { activeAccountWebClientConfig } = useAppContext();
  const { trackError } = useClientLogContext();

  const shouldQuery =
    !!activeAccountWebClientConfig?.activeAccountId && !!buyerEmail;

  return useQuery({
    queryKey: [
      'GetBuyerDetailByEmail',
      activeAccountWebClientConfig?.activeAccountId,
      buyerEmail,
    ],
    async queryFn() {
      if (!shouldQuery || !buyerEmail) return null;
      try {
        return await new RetailClient(
          activeAccountWebClientConfig
        ).getBuyerDetailByEmail(buyerEmail);
      } catch (err: unknown) {
        trackError('RetailClient.getBuyerDetailByEmail', err as ErrorTypes);
        throw err;
      }
    },
    enabled: shouldQuery,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    networkMode: 'offlineFirst',
  });
}
